import { specialSelection } from "../../constants";

export const initialState = {
    pathReportURL: "",
    pathSummaryURL: "",
    templateURL: "",
    coreLocations: [],
    activeCore: specialSelection.NONE_SELECTED,
    isCoreFocused: false,
    isOnMeshViewerControl: false,
};
